export default {
  workshop: null,
  icon: null,
};
